export function verifiedBadgeAccessibilityLabel(verified: boolean) {
  return verified ? 'Verified account' : 'Unverified account';
}

export function verifiedBadgeTooltipText(verified: boolean) {
  return verified
    ? 'Verified account: this user confirmed their email, phone, and identity with Frienzzi.'
    : 'Unverified account: use caution engaging with this user because they have not completed Frienzzi account verification.';
}
